import { create } from 'zustand';

type UseFeaturesFlagState = {
  featuresFlag: Map<string, boolean>;
};

export const useFeaturesFlagState = create<UseFeaturesFlagState>(() => ({ featuresFlag: new Map() }));
